module.exports = __webpack_public_path__ + "static/img/3@2x.fcc072b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/3@2x.png
// module id = o8Tb
// module chunks = 1